import type { FC } from 'react';
import { useEffect, useState } from 'react';

import { useGameConfig } from '../../../../config/GameConfigProvider';
import { Logger } from '../../../../logger/Logger';
import { CoreLocalStorage } from '../../../../storage/local/CoreLocalStorage';
import { useCoreDispatch } from '../../../../store/CoreStore';
import { useConfigSlice } from '../../../../store/slices/config/selectors';
import { useHeaderSlice } from '../../../../store/slices/header/selectors';
import { headerActions } from '../../../../store/slices/header/slice';
import { HeaderModal } from '../../../../store/slices/header/types';
import { useIsLargerThanWide } from '../../../../styles/hooks/media';

import { QuickGuideControlPlain } from './QuickGuideControlPlain';

export const QuickGuideControlConnected: FC = () => {
  const tableId = useConfigSlice.tableId() || '';
  const { quickGuideContent } = useGameConfig();
  const dispatch = useCoreDispatch();
  const openedModal = useHeaderSlice.getCoreOpenedModal();
  const isShown = useHeaderSlice.getQuickGuideIsShown();
  const quickGuideShownCount = CoreLocalStorage.getQuickGuideShownCount(tableId);
  const isWide = useIsLargerThanWide();
  const [timer, setTimer] = useState(!isWide || isShown || quickGuideShownCount >= 3 ? 0 : 10000);

  useEffect(() => {
    let timeOutId: number;

    if (!isShown && quickGuideShownCount < 3) {
      CoreLocalStorage.increaseQuickGuideShownCount(tableId);
      dispatch(headerActions.setQuickGuideShown());

      timeOutId = window.setTimeout(() => {
        setTimer(0);
      }, timer);

      return;
    }

    return () => {
      window.clearTimeout(timeOutId);
    };
  }, [dispatch, isShown, quickGuideShownCount, timer]);

  return (
    quickGuideContent && (
      <QuickGuideControlPlain
        onClick={(): void => {
          if (openedModal === HeaderModal.QuickGuide) {
            dispatch(headerActions.setOpenedModal(null));
          } else {
            Logger.logEvent('click', 'openQuickGuide', Date.now(), 1, '', false);
            dispatch(headerActions.setOpenedModal(HeaderModal.QuickGuide));
          }
        }}
        timer={timer}
        condition={openedModal === HeaderModal.QuickGuide}
      />
    )
  );
};
